'use strict';

define([], function () {

  var responsiveAccountHeader = function responsiveAccountHeader() {
    var component = {};

    var _config = {
      selectors: {
        openAccountPanel: '[data-js-element=responsiveAccountHeader_openAccountPanel]',
        openAccountCheckbox: '.responsiveAccountHeader_openAccount',
        accountOverlay: '.responsiveAccountHeader_overlay',
        accountOverlayLabel: 'label.responsiveAccountHeader_overlay',
        accountLink: '.responsiveAccountHeader_openAccountPanelText',
        dropdownOpenOnClick: false
      },
      classNames: {
        accountOverlayShowClass: 'responsiveAccountHeader_overlay-show'
      },
      attribs: {
        accountDropdownOpened: 'data-js-dropdown-active'
      }
    };

    var _init = function _init(element) {
      component.element = element;

      if ('ontouchstart' in document.documentElement) {
        component.config.dropdownOpenOnClick = true;
      }

      component.openAccountPanel = component.element.querySelector(component.config.selectors.openAccountPanel);
      component.openAccountCheckbox = component.element.querySelector(component.config.selectors.openAccountCheckbox);
      component.accountOverlay = document.querySelector(component.config.selectors.accountOverlay);
      component.accountOverlayLabel = document.querySelector(component.config.selectors.accountOverlayLabel);
      component.accountLink = component.element.querySelector(component.config.selectors.accountLink);

      component.bind();

      return component;
    };

    var _bind = function _bind() {
      if (component.config.dropdownOpenOnClick) {
        component.openAccountPanel.addEventListener('click', component.handleTouch);
        component.accountOverlay.addEventListener('click', component.closeDropdown);
      }
    };

    var _handleTouch = function _handleTouch(e) {
      if (component.openAccountPanel.hasAttribute(component.config.attribs.accountDropdownOpened) || getComputedStyle(component.accountOverlayLabel).opacity === '1') {
        component.openAccountPanel.removeAttribute(component.config.attribs.accountDropdownOpened);
        component.hideOverlay();
      } else {
        e.preventDefault();
        e.stopPropagation();
        component.showOverlay();
        component.openAccountPanel.setAttribute(component.config.attribs.accountDropdownOpened, '');
      }
    };

    var _closeDropdown = function _closeDropdown(e) {
      if (e.target !== component.accountLink) {
        e.preventDefault();
      }
      if (component.openAccountPanel.hasAttribute(component.config.attribs.accountDropdownOpened)) {
        component.openAccountPanel.removeAttribute(component.config.attribs.accountDropdownOpened);
      }
      if (component.openAccountCheckbox.checked) {
        component.openAccountCheckbox.checked = false;
      }
      component.hideOverlay();
    };

    var _showOverlay = function _showOverlay() {
      component.accountOverlay.classList.add(component.config.classNames.accountOverlayShowClass);
    };

    var _hideOverlay = function _hideOverlay() {
      component.accountOverlay.classList.remove(component.config.classNames.accountOverlayShowClass);
    };

    component.config = _config;
    component.init = _init;
    component.bind = _bind;
    component.handleTouch = _handleTouch;
    component.closeDropdown = _closeDropdown;
    component.showOverlay = _showOverlay;
    component.hideOverlay = _hideOverlay;

    return component;
  };

  return responsiveAccountHeader;
});
//# sourceMappingURL=responsiveAccountHeader.js.map
